<template>
  <div
    class="h-7 min-w-12 min-h-7 relative w-12 duration-200 rounded-full"
    :class="{'bg-gray': !value}"
    :style="value ? {background: themeColorHEX} : {}"
  >
    <div
      class="bottom-px2 top-px2 absolute w-6 h-6 duration-200 bg-white rounded-full"
      :class="{'right-px2': value, 'right-[1.375rem]': !value}"
    ></div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-tumbler',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX'])
    }
  }
</script>
